import script from "./Photos.vue?vue&type=script&setup=true&lang=ts"
export * from "./Photos.vue?vue&type=script&setup=true&lang=ts"

import "./Photos.vue?vue&type=style&index=0&id=cd4be0c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4be0c6"]])

export default __exports__